import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-livre-bon-liv-negoce',
  templateUrl: './livre-bon-liv-negoce.component.html',
  styleUrls: ['./livre-bon-liv-negoce.component.scss']
})
export class LivreBonLivNegoceComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
